import { combineReducers } from "redux";
import { appReducer } from "./appReducer";
import { userReducer } from "./userReducer";
import { dashboardReducer } from "./dashboardReducer";
import { studentReducer } from "./studentReducer";
import { connectRouter } from "connected-react-router";
import { feesReducer } from "./feesReducer";
import { paymentReducer } from "./paymentReducer";
import {  notificationReducer } from "./notificationReducer";
import {  reportReducer } from "./reportReducer";
import { pendingPaymentsReducer } from "./pendingPaymentsReducer";
export const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    app: appReducer,
    user: userReducer,
    dashboard: dashboardReducer,
    student: studentReducer,
    fees: feesReducer,
    payment: paymentReducer,
    notification: notificationReducer,
    report: reportReducer,
    pendingPayments: pendingPaymentsReducer
})
